// #region import
import { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import {
  Grid,
  Button,
  CircularProgress
} from '@material-ui/core';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Form from '../components/Form'
import moment from 'moment'

// #endregion

// #region style

const useStyles = makeStyles(() => ({
  fullHeight: {
    height: '100%'
  },
  fullWidth:{
    width: '100%',
    overflowY: 'auto',
    maxHeight: 'calc(100% - 40px)'
  },
  appButton: {
    color: '#4d7ac4',
    textTransform: 'none',
    padding: "20px",
    width: '100%',
    justifyContent: 'space-between',
    fontSize: 'x-large',
    '&:hover': {
      backgroundColor: '#ddd'
    }
  },
  disconnect: {
    color: 'red',
    border: '1px solid red',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'lightred'
    }
  },
}));

// #endregion

const apiUrl = window.apiUrl

function DefaultPage({ updateStatus, setUser }) {

  const classes = useStyles()
  const [token, setToken, deleteToken] = useCookies(['portaltoken'])
  const [applications, setApplications] = useState(null)
  const [loading, setLoading] = useState(false)
  const [doOnce, setDoOnce] = useState(true)

  useEffect(() => {
    if (doOnce) {
      setDoOnce(false)
      if (token['portaltoken']) {
        setLoading(true)
        axios.get(apiUrl + "v2/portal/authtoken", { headers: { portalToken: token['portaltoken'] }})
          .then(response =>
            {
              if (response.data.valid) {
                updateToken(token['portaltoken'])
                setUser(response.data.login)
                loadApplications(token['portaltoken'])
              } else {
                updateStatus("warning", "token not valid anymore")
                deleteToken("portaltoken", { path: '/' })
              }
          })
          .catch(response => {
            deleteToken("portaltoken", { path: '/' })
            updateStatus("error", "error authenticating token " + response.toString())
            setLoading(false)
          })
      }
    }
  }, [doOnce])

  function connectAction(data) {
    updateStatus("success", "Hello " + data.displayName)
    updateToken(data.token)
    loadApplications(data.token)
  }

  function loadApplications(token) {
    setLoading(true)
    axios.get(apiUrl + "v2/portal/getapplicationsforuser", { headers: { portaltoken: token }})
      .then(response => {
        setApplications(response.data)
        setLoading(false)
      })
      .catch(response => {
        updateStatus("error", "error getting apps for user" + response.toString())
        setLoading(false)
      })
  }

  function disconnect() {
    deleteToken("portaltoken", { path: '/' })
    updateStatus("info", "Disconnected")
  }

  function updateToken(value) {
    setToken('portaltoken', value, { path: '/', expires: moment(new Date()).add(15, 'days').toDate() });
  }

  function redirectToApp(app) {
    if (app.nGinxAutentication === true) {
      window.location.href = app.url + "sso_validate?token=" + token['portaltoken']
    } else {
      axios.get(apiUrl + "v2/ssoapplication/loginwithsso", { headers: { portalToken: token['portaltoken'], application: app.applicationName }})
      .then(response => {
        if (response.data.valid) {
            window.location.href = app.url + "Token/" + response.data.token
        } else {
          updateStatus("error", response.data.message)
          setLoading(false)
        }
      })
      .catch(response => {
        updateStatus("error", "error on getting token for app : " + response.toString())
        setLoading(false)
      })
    }
  }

  return (<>
    {loading ?
      <Grid container alignContent="center" justifyContent="center" className={classes.fullHeight}>
        <CircularProgress />
      </Grid>
      :
      <>
        {token['portaltoken'] ?
          <Grid container direction="column" alignContent="center" justifyContent="space-between" className={classes.fullHeight}>
            <div className={classes.fullWidth}>
              {
                applications?.map(app => (
                  <Button
                    key={app.applicationName}
                    endIcon={<ArrowForwardIosIcon />}
                    className={classes.appButton}
                    onClick={() => {redirectToApp(app)}}>
                    {app.applicationName}
                  </Button>
                ))
              }
            </div>
            <Button endIcon={<ExitToAppIcon />} className={classes.disconnect} onClick={disconnect}>
              Disconnect
            </Button>
          </Grid>
          :
          <Form connectAction={(data) => connectAction(data)} updateStatus={updateStatus} />
        }
      </>
    }
  </>
  )
}

export default DefaultPage;